export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_15-7896f67251a268cbdb53c68215d2f5d2.jpg";